import { render, staticRenderFns } from "./standByScreen.vue?vue&type=template&id=e4791a18&scoped=true&"
import script from "./standByScreen.vue?vue&type=script&lang=ts&"
export * from "./standByScreen.vue?vue&type=script&lang=ts&"
import style0 from "./standByScreen.vue?vue&type=style&index=0&id=e4791a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4791a18",
  null
  
)

export default component.exports